export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"author","content":"Duncan de Klerk"},{"name":"app-mobile-web-app-title","content":"Airabica Roasters"},{"name":"application-name","content":"Airabica Roasters"},{"name":"msapplication-TileColor","content":"#cc9966"},{"name":"msapplication-config","content":"/images/icons/browserconfig.xml"}],"link":[{"rel":"dns-prefetch","href":"//fonts.googleapis.com"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"./images/icons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"./images/icons/favicon-16x16.png"},{"rel":"shortcut icon","href":"./images/icons/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"./images/icons/apple-touch-icon.png"},{"rel":"manifest","href":"./images/icons/site.webmanifest"},{"rel":"mask-icon","color":"#666666","href":"./images/icons/safari-pinned-tab.svg"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700%7CPoppins:300,400,500,600,700","defer":true}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"